import { TopBannerMessage } from '@post-office/jira-common/components/top-banner-message';
// @ts-expect-error: 'React' is declared but its value is never read
import React from 'react';

import { createRender, type HydrationResult } from './types';
import { type JSX } from 'react/jsx-runtime';

export const render: (renderProps: Omit<HydrationResult, 'postOffice'>) => JSX.Element | null =
	createRender(() => <TopBannerMessage />);

export default render;
